import { __extends } from "tslib";
import { SdkMessageTypes } from '../constants';
import { validLegacyLinkOrigin } from '../utils/helpers';
import { BaseMessageHandler } from './base-message-handler';
import { onSdkError } from './messageHandlingUtils';
import { callServiceAndFormulateLogMessageResult } from './messageHandlingUtils';
var AppInstallDialogMessageHandler = /** @class */ (function (_super) {
    __extends(AppInstallDialogMessageHandler, _super);
    function AppInstallDialogMessageHandler(appSdkHost, appInstallDialogService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.appInstallDialogService = appInstallDialogService;
        return _this;
    }
    AppInstallDialogMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.appInstallDialog.openAppInstallDialog, function (_, openAppInstallDialogParams) {
            return callServiceAndFormulateLogMessageResult(_this.appInstallDialogService.openAppInstallDialog, openAppInstallDialogParams);
        }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.appInstallDialog.openAppInstallDialog, error, scenario);
            },
        });
    };
    AppInstallDialogMessageHandler.prototype.validateDependencies = function () {
        if (!this.appInstallDialogService) {
            throw 'No appInstallDialogService provided';
        }
    };
    return AppInstallDialogMessageHandler;
}(BaseMessageHandler));
export { AppInstallDialogMessageHandler };
var AppInstallDialogLegacyLinkHandler = /** @class */ (function () {
    function AppInstallDialogLegacyLinkHandler(appInstallDialogService) {
        this.appInstallDialogService = appInstallDialogService;
    }
    AppInstallDialogLegacyLinkHandler.prototype.tryGetDataFromLink = function (url) {
        if (!this.appInstallDialogService) {
            return null;
        }
        if (url.origin != validLegacyLinkOrigin) {
            return null;
        }
        var matches = url.pathname.match(AppInstallDialogLegacyLinkHandler.APP_INSTALL_DIALOG_URL_REGEX);
        if (!matches) {
            return null;
        }
        return {
            appId: matches[1],
        };
    };
    AppInstallDialogLegacyLinkHandler.prototype.executeData = function (ppenAppInstallDialogParams) {
        return this.appInstallDialogService.openAppInstallDialog(ppenAppInstallDialogParams);
    };
    // This is looking for a URL with this pattern: "/l/app/<app id>/"
    AppInstallDialogLegacyLinkHandler.APP_INSTALL_DIALOG_URL_REGEX = /^\/l\/app\/([^\/]+)\/?$/;
    return AppInstallDialogLegacyLinkHandler;
}());
export { AppInstallDialogLegacyLinkHandler };
//# sourceMappingURL=appInstallDialog-message-handler.js.map